import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=70daa136&scoped=true&"
import script from "./PanelLayout.vue?vue&type=script&lang=js&"
export * from "./PanelLayout.vue?vue&type=script&lang=js&"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&id=70daa136&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70daa136",
  null
  
)

export default component.exports